import { createStyles } from '@material-ui/core';
import { Theme } from "@material-ui/core/styles";



/* eslint-disable */ // TODO: need to remove

const styles = (theme1:Theme) => createStyles({  
  hidden: {
    display: 'none',
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    zIndex: 9999,
    overflow: 'auto',
    animation: 'loadingOpen 0.2s ease-in-out',
    pointerEvents: 'none',

    '&.closing': {
      opacity: 0,
      transform: 'scale(0.25)',
      transition: 'opacity 0.2s ease-in-out, transform 0.2s ease-in-out',
    },
  },
  spinnerBackground: {
    backgroundColor: 'white',
    background: 'black',
    position: 'fixed',
    zIndex: 8000,
    height: '100%',
    width: '100%',
    top: '0',
    left: '0',
  },
  spinnerColor: {
  },
  '@keyframes loadingOpen': {
    from: {
      opacity: 0,
      transform: 'scale(0.25)',
    },
    to: {
      opacity: 1,
      transform: 'scale(1)',
    },
  },
  '@keyframes loadingSpinnerSpin': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // height: '200px',
    backgroundColor: "white",
    padding: '40px 80px',
    borderRadius: '2px',
    border: `1px solid #FFFFFF`,
    pointerEvents: 'all',
    [theme1.breakpoints.down('sm')]: {
      padding: '40px 40px',
    }
  },
  headingMain: {
    ...theme1.custom.styles.headerSpinner,
    margin: '10px 0 0 8px',
    textAlign: 'center',
    //color: theme1.custom.colors.loadingSpinnerHeaderColor
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    padding: '20px 0px',
    [theme1.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
    }
  },
  top: {
    color: theme1.custom.colors.loadingSpinnerTopColor,
  },
  bottom: {
    animationDuration: '0.75s',
    color: theme1.custom.colors.loadingSpinnerBottomColor,
    position: 'absolute',
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      marginTop: '-80px',
      marginLeft: '-40px',
    },
  },
  spinnerWidth: {
    // used to set the width of the loading spinner and override material
    strokeDasharray: '40px, 200px !important',
  }
});

export { styles };
